import Icon from "@Components/generic/icon";
import UserProgressStats from "@Enums/UserProgressStats";
import { faClockThree, faFire, IconDefinition } from "@fortawesome/pro-regular-svg-icons";
import SportsSoccerOutlinedIcon from "@mui/icons-material/SportsSoccerOutlined";
import { Box, SvgIcon, useTheme } from "@mui/material";
import { ReactElement } from "react";

interface IUserStats {
  userStat: UserProgressStats;
  size?: number;
}

type IconType = IconDefinition | ReactElement;

const UserStatsIcon = ({ userStat, size = 6 }: IUserStats) => {
  const theme = useTheme();

  const userStatIconMap: { [key in UserProgressStats]: { icon: IconType; iconColor: string; bgColor: string } } = {
    [UserProgressStats.ACTIVITY]: {
      icon: faClockThree,
      iconColor: theme.palette.dsDestructive.v300,
      bgColor: theme.palette.dsDestructive.v100,
    },
    [UserProgressStats.TRAINING]: {
      icon: <SportsSoccerOutlinedIcon />,
      iconColor: theme.palette.dsPrimary.v300,
      bgColor: theme.palette.dsPrimary.v100,
    },
    [UserProgressStats.WEEKLY_TRAINING]: {
      icon: faFire,
      iconColor: theme.palette.dsWarning.v300,
      bgColor: theme.palette.dsWarning.v100,
    },
  };

  const { icon, iconColor, bgColor } = userStatIconMap[userStat];

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        borderRadius: "25%",
        width: theme.spacing(size),
        height: theme.spacing(size),
        backgroundColor: bgColor,
      }}
    >
      {icon instanceof Object && !("iconName" in icon) ? (
        <SvgIcon sx={{ color: iconColor, fontSize: theme.spacing(size / 2) }}>{icon}</SvgIcon>
      ) : (
        <Icon icon={icon} color={iconColor} sx={{ fontSize: theme.spacing(size / 2) }} />
      )}
    </Box>
  );
};

export default UserStatsIcon;
